import { useState } from 'react';
import { FACTORSTREET_LOGO_SRC, getAddressInitials, isInternalFactorStreetAddress } from './emailUtils';

function EmailAvatar({ address, size = 'md' }) {
  const [logoFailed, setLogoFailed] = useState(false);
  const isInternal = isInternalFactorStreetAddress(address);
  const initials = isInternal ? 'FS' : getAddressInitials(address);

  return (
    <span
      aria-hidden="true"
      className={`admin-email-avatar admin-email-avatar--${size} ${isInternal ? 'is-factorstreet' : ''}`}
    >
      {isInternal && !logoFailed ? (
        <img alt="" onError={() => setLogoFailed(true)} src={FACTORSTREET_LOGO_SRC} />
      ) : (
        <span>{initials}</span>
      )}
    </span>
  );
}

export default EmailAvatar;
